import React from "react";
export default function LabelText(props: any) {
  return (
    <>
      {props.text && (
        <label className="text-[#787878] text-lg ubermoveTextMedium mb-0">
          {props.text}
        </label>
      )}
    </>
  );
}
